module.exports = __webpack_public_path__ + "img/attachments.5fc85211.svg";